import { Link } from 'react-router-dom';

export default function NominateHub() {
  return (
    <div className="mx-auto max-w-3xl px-4 py-12">
      <header className="text-center mb-10">
        <h1 className="text-3xl font-bold text-cocoa">Nominate Someone</h1>
        <p className="mt-2 text-cocoa/70 max-w-xl mx-auto">
          Know a teacher who deserves a classroom, or a young athlete who needs support?
          Nominate them for a chance to be selected in our next community draw.
        </p>
      </header>

      <div className="grid gap-6 sm:grid-cols-2 mb-10">
        {/* Teacher Card */}
        <Link
          to="/nominate/teacher"
          className="group rounded-2xl border-2 border-amber-200 bg-gradient-to-br from-amber-50 to-orange-50 p-6 text-left transition-all hover:border-amber-400 hover:shadow-lg"
        >
          <div className="mb-4 flex h-14 w-14 items-center justify-center rounded-xl bg-amber-100 text-2xl group-hover:scale-110 transition-transform">
            📚
          </div>
          <h2 className="text-xl font-bold text-cocoa">Nominate a Teacher</h2>
          <p className="mt-2 text-sm text-cocoa/70">
            Anyone can nominate a teacher. They'll receive an email to confirm with their official
            school email, then enter the pool for the next classroom draw.
          </p>
          <div className="mt-4 flex items-center gap-2 text-sm font-semibold text-amber-700">
            Get started <span className="group-hover:translate-x-1 transition-transform">&rarr;</span>
          </div>
        </Link>

        {/* Prospect Card */}
        <Link
          to="/nominate/prospect"
          className="group rounded-2xl border-2 border-sky-200 bg-gradient-to-br from-sky-50 to-blue-50 p-6 text-left transition-all hover:border-sky-400 hover:shadow-lg"
        >
          <div className="mb-4 flex h-14 w-14 items-center justify-center rounded-xl bg-sky-100 text-2xl group-hover:scale-110 transition-transform">
            🏃
          </div>
          <h2 className="text-xl font-bold text-cocoa">Nominate a Prospect</h2>
          <p className="mt-2 text-sm text-cocoa/70">
            Coaches nominate young athletes. As the adult guardian, you'll own the locker room
            and manage resources if they're selected in the draw.
          </p>
          <div className="mt-4 flex items-center gap-2 text-sm font-semibold text-sky-700">
            Get started <span className="group-hover:translate-x-1 transition-transform">&rarr;</span>
          </div>
        </Link>
      </div>

      {/* Rally Board + Pool CTAs */}
      <div className="grid gap-4 sm:grid-cols-2">
        <div className="rounded-2xl border border-sand bg-white/80 p-6 text-center shadow-soft">
          <h3 className="text-lg font-semibold text-cocoa">The Rally Board</h3>
          <p className="mt-1 text-sm text-cocoa/70">
            See who's campaigning for the next draw. Support your favorites to boost their chances.
          </p>
          <Link
            to="/rally"
            className="mt-4 inline-block rounded-xl bg-brick px-6 py-2.5 text-sm font-semibold text-white transition hover:bg-brickDark"
          >
            Visit the Rally Board
          </Link>
        </div>
        <div className="rounded-2xl border-2 border-cocoa/20 bg-gradient-to-br from-cocoa/5 to-white p-6 text-center shadow-soft">
          <h3 className="text-lg font-semibold text-cocoa">Already nominated?</h3>
          <p className="mt-1 text-sm text-cocoa/70">
            Enter The Pool — your nominee portal. See ceremony countdown, post to the Rally Board, and share your support link.
          </p>
          <Link
            to="/portal/nominee"
            className="mt-4 inline-block rounded-xl bg-cocoa px-6 py-2.5 text-sm font-semibold text-white transition hover:bg-cocoa/90"
          >
            Enter The Pool →
          </Link>
        </div>
      </div>

      {/* How it works */}
      <div className="mt-10 space-y-4">
        <h3 className="text-lg font-semibold text-cocoa text-center">How It Works</h3>
        <div className="grid gap-4 sm:grid-cols-4">
          {[
            { step: '1', title: 'Nominate', desc: 'Submit a nomination for a teacher or prospect.' },
            { step: '2', title: 'Confirm', desc: 'Nominee confirms via email and enters the pool.' },
            { step: '3', title: 'Rally', desc: 'Share your support link. Each vote adds weight.' },
            { step: '4', title: 'Draw', desc: 'Weighted random draw selects winners when funding hits the milestone.' },
          ].map((s) => (
            <div key={s.step} className="text-center">
              <div className="mx-auto mb-2 flex h-10 w-10 items-center justify-center rounded-full bg-brick/10 text-sm font-bold text-brick">
                {s.step}
              </div>
              <h4 className="text-sm font-semibold text-cocoa">{s.title}</h4>
              <p className="mt-1 text-xs text-cocoa/60">{s.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
